import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const powerCycleStacklet = (id: number): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { action: 'power_cycle' },
  });
